import { jsx as _jsx } from "react/jsx-runtime";
import { ConfigurationResumer, } from "./ConfigurationResumer";
import { ConfigurationStarter, } from "./ConfigurationStarter";
/**
 * Depending on params, mounts the ConfigurationLoader or ConfigurationStarter
 * - requires {@linkcode ConfigurationController}
 *
 * @category Controller
 * @param props
 * @throws {Error} Throws error on invalid options
 */
export function ConfigurationInitializer(props) {
    if (!props.localeId) {
        throw new Error("The option localeId is required in <ConfigurationInitializer/>");
    }
    if ("sessionId" in props && props.sessionId) {
        return _jsx(ConfigurationResumer, Object.assign({}, props));
    }
    return _jsx(ConfigurationStarter, Object.assign({}, props));
}
//# sourceMappingURL=ConfigurationInitializer.js.map